import { REGISTRATION_CHECK_REQUEST,
    REGISTRATION_CHECK_SUCCESS,
    REGISTRATION_CHECK_FAILURE,
} from 'actions/registrationCheckActions';
import moment from 'moment';

export function registrationCheckReducer (state = {
  lastRequestTime: undefined,
  inError: false,
  checkValue: false,
}, action) {
  switch (action.type) {
    case REGISTRATION_CHECK_FAILURE:
      return {
        ...state,
        checkValue: action.payload,
        lastRequestTime: moment.utc().unix(),
        inError: true
      }
    case REGISTRATION_CHECK_SUCCESS:
      return {
          ...state,
          checkValue: true,
          lastRequestTime: moment.utc().unix(),
          inError: false
      }
    default:
      return state;
  }
}
